import React, { FC } from "react"
import { getTimeSlotLabel } from "../../../Enums/TimeSlot"
import type { PreferredSlot } from "../../../Types/BookingTypes"

interface PreferredSlotsProps {
  slots: PreferredSlot[]
  status: string
  requiresAttendee?: boolean | null
  onApprove?: (slotId: number) => void
}

const PreferredSlots: FC<PreferredSlotsProps> = ({ slots, status, requiresAttendee, onApprove }) => {
  // ステータスに応じた表示ロジック
  const isApproved = status === 'approved'
  const isUnapproved = status === 'unapproved'
  const isCallout = status === 'callout'
  
  // 承認済みの場合は確定日のみ表示
  // 未承認・架電予定の場合は全ての希望日を表示
  const displaySlots = isApproved 
    ? slots.filter(slot => slot.isFixed === true)
    : slots.sort((a, b) => (a.preferenceOrder || 0) - (b.preferenceOrder || 0))

  const formatDate = (dateString: string | null): string => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return date.toLocaleDateString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  }

  return (
    <div className="flex flex-col gap-4">
      {displaySlots.length === 0 ? (
        <div className="text-gray-500 text-center py-8">
          希望日が設定されていません
        </div>
      ) : (
        displaySlots.map((slot, index) => {
          const isFixed = slot.isFixed === true
          const isConfirmed = isApproved && isFixed
          
          return (
            <div
              key={slot.id}
              className={`bg-white border-2 rounded-xl p-6 flex justify-between items-center ${
                isConfirmed
                  ? 'border-green-500 bg-green-50'
                  : 'border-gray-200'
              }`}
            >
              <div className="flex flex-col gap-1">
                <div className="font-semibold text-lg text-gray-900">
                  第{slot.preferenceOrder || index + 1}希望: {formatDate(slot.date)}
                  {isConfirmed && '（確定）'}
                </div>
                <div className="text-gray-600 text-sm">
                  {slot.timeSlot ? getTimeSlotLabel(slot.timeSlot) : '-'}
                </div>
                {isConfirmed && requiresAttendee !== null && requiresAttendee !== undefined && (
                  <div className="text-gray-600 text-sm">
                    立合い: {requiresAttendee ? 'あり' : 'なし'}
                  </div>
                )}
              </div>
              {/* 未承認または架電予定の場合、is_fixedがfalseの希望日に承認ボタンを表示 */}
              {(isUnapproved || isCallout) && !isFixed && (
                <button
                  onClick={() => onApprove?.(slot.id)}
                  className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-green-500 text-white rounded-lg text-sm font-medium transition-all hover:bg-green-600 hover:-translate-y-0.5 hover:shadow-md hover:cursor-pointer focus:outline-none focus:ring-3 focus:ring-green-500/10 min-h-[2.5rem]"
                >
                  承認手続きへ
                </button>
              )}
            </div>
          )
        })
      )}
    </div>
  )
}

export default PreferredSlots

